import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    cults: [],
    page: 1,
    page_size: 10,
    total: 0,
    page_count: 0,
    order_column: 'id',
    order_type: 'desc',
    selectedCult: null,
    editModalVisible: false
  },

  mutations: {
    setCults(state, payload) {
      state.cults = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setTotal(state, payload) {
      state.total = payload
    },
    setPageCount(state, payload) {
      state.page_count = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedCult(state, payload) {
      state.selectedCult = payload
    },
    setEditModalVisible(state, payload) {
      state.editModalVisible = payload
    },
    reset(state) {
      state.cults = []
      state.page = 1
      state.page_size = 10
      state.total = 0
      state.page_count = 0
      state.order_column = 'id'
      state.order_type = 'desc'
      state.loading = false
      state.selectedCult = null
      state.editModalVisible = false
    }
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('/web3/cults', {
          params: {
            sort: 'new',
            page: state.page,
            perPage: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setCults', r.data.data)
          commit('setTotal', r.data.total)
          commit('setPageCount', r.data.last_page)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    update({ commit, dispatch, state }, cult) {
      commit('setLoading', true)
      return axios.admin
        .put(`/web3/cults/${cult.id}`, {
          name: cult.name,
          description: cult.description
        })
        .then(() => {
          commit('setEditModalVisible', false)
          commit('setSelectedCult', null)
          dispatch('read')
          commit('setLoading', false)
          return Promise.resolve()
        })
        .catch(error => {
          commit('setLoading', false)
          return Promise.reject(error)
        })
    }
  },

  getters: {
    getCults(state) {
      return state.cults
    }
  }
}
